import { render } from "./PopUpChangePassword.vue?vue&type=template&id=1f4d239a&scoped=true"
import script from "./PopUpChangePassword.vue?vue&type=script&lang=js"
export * from "./PopUpChangePassword.vue?vue&type=script&lang=js"

import "./PopUpChangePassword.vue?vue&type=style&index=0&id=1f4d239a&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4d239a"]])

export default __exports__